import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";

export const renderSecureNotes = ({ store }) => {
  ReactDOM.render(<App store={store} />, document.getElementById("root"));
};
